import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import AdditionalPackage from "./AdditionalPackage";
import App from "./App";
import RechargeNew from "./Components/RechargeNew";
import Home from "./Home";
import IntelligentControl from "./IntelligentControl";
import MyProgram from "./MyProgram";
import Portability from "./Portability";
import Program from "./Program";
import Recharge from "./Recharge";
import RechargeIntelligentControl from "./RechargeIntelligentControl";
import Settings from "./Settings";
import Wallet from "./Wallet";

import * as serviceWorker from "./serviceWorker";
import "./style/index.css";

import { ContextDebitProvider } from "./contexts/DebitContext";
import { GlobalContextProvider } from "./contexts/stepsContext";
import { CardContextProvider } from "./contexts/CardContext";
import { ClientContextProvider } from "./contexts/ClientContext";
import { ActionsProvider } from "./Actions/provider";

import { SMS_ACTIONS_CONFIG, QR_CODE_ACTIONS_CONFIG, SMART_CONTROL_CONFIG } from "./Actions/utils";

ReactDOM.render(
  <BrowserRouter basename="/recargacorreios">
    <ClientContextProvider>
      <CardContextProvider>
        <GlobalContextProvider>
          <ContextDebitProvider>
            <Switch>
              <Route path="/MinhaProgramada" component={MyProgram} />
              <Route path="/Programada" component={Program} />
              <Route path="/Carteira" component={Wallet} />
              <Route path="/Recarga" component={Recharge} />
              <Route path="/Recarga2" component={RechargeNew} />
              <Route
                path="/ControleInteligente"
                component={IntelligentControl}
              />
              <Route
                path="/RecargaControleInteligente"
                component={RechargeIntelligentControl}
              />
              <Route path="/PacoteAdicional" component={AdditionalPackage} />
              <Route path="/Home" component={Home} />
              <Route path="/Portabilidade" component={Portability} />
              <Route path="/Configuracoes" component={Settings} />

              <Route
                path={QR_CODE_ACTIONS_CONFIG.BASE_PATH}
                component={() => (
                  <ActionsProvider ACTIONS_CONFIG={QR_CODE_ACTIONS_CONFIG} />
                )}
              />

              <Route
                path={SMS_ACTIONS_CONFIG.BASE_PATH}
                component={() => (
                  <ActionsProvider ACTIONS_CONFIG={SMS_ACTIONS_CONFIG} />
                )}
              />

              <Route
                path={SMART_CONTROL_CONFIG.BASE_PATH}
                component={() => (
                  <ActionsProvider ACTIONS_CONFIG={SMART_CONTROL_CONFIG} />
                )}
              />

              <Route path="/" component={App} />
            </Switch>
          </ContextDebitProvider>
        </GlobalContextProvider>
      </CardContextProvider>
    </ClientContextProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
